/* BNB product page v3 (template suffix "bnb"). Companion: bnb-pdp.css. Built 11 Oct 2026.
   Three small jobs: tabs, "on this page" links built from the description headings, and holding the
   sticky add-to-cart bar down until the main button has scrolled out of view. No cart logic lives here. */
(function () {
  'use strict';

  /* ---- Tabs (Overview / Nutrition / How to use / Warnings) ---- */
  function initTabs() {
    var bar = document.querySelector('.bnbp-tabs');
    if (!bar) return;
    var tabs = Array.prototype.slice.call(bar.querySelectorAll('.bnbp-tab'));
    var panels = Array.prototype.slice.call(document.querySelectorAll('.bnbp-panel'));
    function select(tab) {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
      panels.forEach(function (p) { p.classList.toggle('is-active', p.id === tab.getAttribute('aria-controls')); });
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { select(t); }); });
    /* Deep links: #tab-nutrition opens that tab. */
    var hash = (location.hash || '').replace('#', '');
    var wanted = tabs.filter(function (t) { return t.getAttribute('aria-controls') === hash; })[0];
    if (wanted) select(wanted);
  }

  /* ---- Jump links from the article headings (h2/h3). Adds ids where missing. ---- */
  function slug(text) {
    return text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'section';
  }
  function initJumpLinks() {
    var article = document.querySelector('.bnb-article');
    if (!article) return;
    var heads = Array.prototype.slice.call(article.querySelectorAll('h2, h3'));
    if (heads.length < 2) {
      /* Nothing to navigate: drop the rail and let the article take the full width. */
      var details = document.querySelector('.bnb-details');
      if (details) details.classList.add('bnb-details--single');
      return;
    }
    var used = {};
    var items = heads.map(function (h) {
      var id = h.id || slug(h.textContent);
      while (used[id]) id += '-2';
      used[id] = true;
      h.id = id;
      return { id: id, text: h.textContent.trim(), el: h };
    });
    /* Phones and narrow windows: a collapsed "On this page" menu (details/summary) */
    var jump = document.querySelector('.bnb-jump');
    if (jump) {
      var list = jump.querySelector('ol');
      if (list) list.innerHTML = items.map(function (i) { return '<li><a href="#' + i.id + '">' + escapeHtml(i.text) + '</a></li>'; }).join('');
      var count = jump.querySelector('.bnb-jump__count');
      if (count) count.textContent = items.length + ' sections';
      jump.classList.add('has-items');
      jump.addEventListener('click', function (e) { if (e.target.closest('a')) jump.open = false; });
    }
    /* Desktop rail */
    var rail = document.querySelector('.bnb-rail ol');
    if (rail) {
      rail.innerHTML = items.map(function (i) { return '<li><a href="#' + i.id + '">' + escapeHtml(i.text) + '</a></li>'; }).join('');
      var links = Array.prototype.slice.call(rail.querySelectorAll('a'));
      if ('IntersectionObserver' in window) {
        var current = null;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              current = e.target.id;
              links.forEach(function (a) { a.classList.toggle('is-current', a.getAttribute('href') === '#' + current); });
            }
          });
        }, { rootMargin: '-20% 0px -70% 0px', threshold: 0 });
        items.forEach(function (i) { io.observe(i.el); });
      }
    }
    /* Clicking a jump link while another tab is open: switch back to Overview first. */
    document.addEventListener('click', function (e) {
      var a = e.target.closest('.bnb-jump a, .bnb-rail a');
      if (!a) return;
      var overview = document.querySelector('.bnbp-tab[aria-controls="bnb-panel-overview"]');
      if (overview && overview.getAttribute('aria-selected') !== 'true') overview.click();
    });
  }
  function escapeHtml(s) {
    return s.replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  /* ---- Shape the article so the long description reads as sections, not one wall of text.
     Works on the SHAPE of the content, not on any product's words, so it holds across the catalogue:
     - a list whose items start with a bold label ("Energy: ...") becomes a grid of cards
     - a list of short plain items (flavours) becomes chips
     - the "side effects", "price per serve" and "how to take" sections become callout boxes ---- */
  function shapeArticle() {
    var article = document.querySelector('.bnb-article');
    if (!article) return;
    /* Lists */
    article.querySelectorAll('ul').forEach(function (ul) {
      if (ul.closest('ul, ol') !== ul || ul.querySelector('ul, ol')) return;
      var items = Array.prototype.slice.call(ul.children).filter(function (li) { return li.tagName === 'LI'; });
      if (items.length < 2) return;
      var labelled = items.filter(function (li) {
        var first = li.firstElementChild;
        return first && (first.tagName === 'STRONG' || first.tagName === 'B') && li.textContent.trim().length > first.textContent.trim().length + 3;
      }).length;
      var short = items.filter(function (li) { return li.textContent.trim().length <= 64 && !li.querySelector('strong, b'); }).length;
      if (labelled >= Math.max(2, Math.ceil(items.length * 0.6))) {
        ul.classList.add('bnb-cards');
        items.forEach(function (li) {
          var first = li.firstElementChild;
          if (first && (first.tagName === 'STRONG' || first.tagName === 'B')) {
            var last = first.lastChild;
            if (last && last.nodeType === 3) last.nodeValue = last.nodeValue.replace(/\s*:\s*$/, '');
            var next = first.nextSibling;
            if (next && next.nodeType === 3) {
              var t = next.nodeValue.replace(/^\s*:?\s*/, '');
              if (t) next.nodeValue = ' ' + t.charAt(0).toUpperCase() + t.slice(1);
            }
          }
        });
      } else if (short === items.length && items.length >= 3) {
        ul.classList.add('bnb-chips');
      }
    });
    /* Callouts: heading + everything up to the next heading */
    var rules = [
      { re: /side effect|who should avoid|who should not|warning|caution/i, cls: 'bnb-callout--warn' },
      { re: /price per serve|cost per serve|value/i, cls: 'bnb-callout--stat' },
      { re: /how to (take|use|mix|drink)|directions|when to take/i, cls: 'bnb-callout--how' }
    ];
    Array.prototype.slice.call(article.querySelectorAll('h2, h3')).forEach(function (h) {
      var rule = rules.filter(function (r) { return r.re.test(h.textContent); })[0];
      if (!rule) return;
      var box = document.createElement('div');
      box.className = 'bnb-callout ' + rule.cls;
      h.parentNode.insertBefore(box, h);
      var node = h;
      while (node && !(node !== h && /^H[1-4]$/.test(node.tagName))) {
        var next = node.nextSibling;
        box.appendChild(node);
        node = next;
      }
    });
  }

  /* ---- Products linked from the description get a photo and price.
     bnb-pdp-details.liquid hands over the linked products as JSON ([data-bnb-linked]). Two shapes:
     - a card whose bold label IS a product link (compare lists, "Disorder or Disorder Pump?") becomes a
       product card: photo on the left, name, price, then the text
     - a card with product links inside the text ("Creatine: ... try X or Y") keeps its text and gets a row
       of product chips (photo + name + price) under it, up to three
     In a compare list, a card with no link whose label is part of this product's name shows this product. ---- */
  function dressProducts() {
    var src = document.querySelector('[data-bnb-linked]');
    var article = document.querySelector('.bnb-article');
    if (!src || !article) return;
    var list;
    try { list = JSON.parse(src.textContent).filter(Boolean); } catch (e) { return; }
    var byHandle = {}, current = null;
    list.forEach(function (p) { byHandle[p.handle] = p; if (p.current) current = p; });
    function handleOf(a) {
      var m = (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
      return m ? m[1] : null;
    }
    function priceOf(p) { return p.available === false ? 'Sold out' : (p.varies ? 'From ' : '') + p.price; }
    function img(p, w) { return '<img src="' + p.img + '" alt="" loading="lazy" width="' + w + '" height="' + w + '">'; }
    article.querySelectorAll('ul.bnb-cards').forEach(function (ul) {
      var items = Array.prototype.slice.call(ul.children).filter(function (li) { return li.tagName === 'LI'; });
      var plan = items.map(function (li) {
        var label = li.firstElementChild;
        var hasLabel = !!(label && (label.tagName === 'STRONG' || label.tagName === 'B'));
        var seen = {}, products = [];
        Array.prototype.slice.call(li.querySelectorAll('a[href*="/products/"]')).forEach(function (a) {
          var h = handleOf(a);
          if (h && byHandle[h] && !seen[h]) { seen[h] = true; products.push({ p: byHandle[h], name: a.textContent.trim() }); }
        });
        var labelLink = hasLabel ? label.querySelector('a[href*="/products/"]') : null;
        var main = labelLink ? byHandle[handleOf(labelLink)] : null;
        return { li: li, label: hasLabel ? label : null, main: main || null, products: products };
      });
      var compareList = plan.some(function (x) { return x.main; });
      plan.forEach(function (x) {
        if (!x.main && compareList && !x.products.length && x.label && current) {
          var t = x.label.textContent.replace(/:\s*$/, '').trim().toLowerCase();
          if (t.length >= 3 && current.title.toLowerCase().indexOf(t) !== -1) x.main = current;
        }
        var li = x.li;
        if (x.main) {
          var body = document.createElement('div');
          body.className = 'bnb-card__body';
          while (li.firstChild) body.appendChild(li.firstChild);
          li.classList.add('bnb-card--product');
          li.insertAdjacentHTML('afterbegin', '<a class="bnb-card__thumb" href="' + x.main.url + '" tabindex="-1" aria-hidden="true">' + img(x.main, 120) + '</a>');
          li.appendChild(body);
          var price = document.createElement('span');
          price.className = 'bnb-card__price';
          price.textContent = (x.main.current ? 'This product · ' : '') + priceOf(x.main);
          if (body.firstElementChild) body.firstElementChild.insertAdjacentElement('afterend', price);
        }
        var chips = x.products.filter(function (c) { return !x.main || c.p.handle !== x.main.handle; }).slice(0, 3);
        if (chips.length) {
          var row = document.createElement('div');
          row.className = 'bnb-card__products';
          chips.forEach(function (c) {
            row.insertAdjacentHTML('beforeend', '<a class="bnb-pchip" href="' + c.p.url + '">' + img(c.p, 68) + '<span><b>' + escapeHtml(c.name || c.p.title) + '</b><small>' + escapeHtml(priceOf(c.p)) + '</small></span></a>');
          });
          (li.querySelector('.bnb-card__body') || li).appendChild(row);
        }
      });
    });
  }

  /* ---- Pickup line: say where Caringbah is. The theme renders this block after fetching availability,
     so wait for it. "Booty N Buff Caringbah" is the Shopify location name; we add ", Sydney" after it. ---- */
  function initPickup() {
    var host = document.querySelector('.section-main-product');
    if (!host || !('MutationObserver' in window)) return;
    function fix() {
      host.querySelectorAll('pickup-availability .pickup-status strong').forEach(function (s) {
        if (!/sydney/i.test(s.textContent)) s.textContent = s.textContent.trim() + ', Sydney';
      });
    }
    new MutationObserver(fix).observe(host, { childList: true, subtree: true });
    fix();
  }

  /* ---- Wrap wide tables so they scroll sideways on a phone instead of breaking the layout ---- */
  function wrapTables() {
    document.querySelectorAll('.bnb-article table').forEach(function (t) {
      if (t.parentElement.classList.contains('bnb-table-wrap')) return;
      var w = document.createElement('div');
      w.className = 'bnb-table-wrap';
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
    });
  }

  /* ---- Sticky add-to-cart bar: show only after the main button has scrolled above the viewport ---- */
  function initStickyGate() {
    var btn = document.querySelector('.section-main-product button[name="add"]');
    if (!btn) { document.body.classList.add('bnb-atc-passed'); return; }
    var ticking = false;
    function check() {
      ticking = false;
      var passed = btn.getBoundingClientRect().bottom < 0;
      document.body.classList.toggle('bnb-atc-passed', passed);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
    check();
  }

  function init() {
    initTabs();
    wrapTables();
    shapeArticle();
    dressProducts();
    initJumpLinks();
    initStickyGate();
    initPickup();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
